module.exports = __webpack_public_path__ + "img/yuyue-banner.cfd6d05d.jpg";